import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import React from 'react';
import { connect } from 'react-redux';

import {
    Bundle,
} from '../../public/components/General';
import {
    getKeyByValue,
    reverseRoute,
} from '../../public/utils/common';

import {
    pathNames,
    pageTitles,
} from '../../common/constants';

import {
    equityActiveTickerSelector,
} from '../selectors/domainData.js';

import {
    setActiveEquityAction,
} from '../action-creators/domainData.js';

const propTypes = {
    match: PropTypes.shape({
        location: PropTypes.string,
        params: PropTypes.shape({
            dummy: PropTypes.string,
        }),
    }).isRequired,

    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,

    activeTicker: PropTypes.string,
};

const defaultProps = {
    activeTicker: undefined,
};

const mapStateToProps = state => ({
    activeTicker: equityActiveTickerSelector(state),
});

const mapDispatchToProps = dispatch => ({
    setActiveTicker: params => dispatch(setActiveEquityAction(params)),
});

@connect(mapStateToProps, mapDispatchToProps)
class RouteSynchronizer extends React.PureComponent {
    static propTypes = propTypes;
    static defaultProps = defaultProps;

    constructor(props) {
        super(props);

        this.synchronizeLocation(props);
    }

    componentWillMount() {
        console.log('Mounting RouteSynchronizer');
    }

    componentWillReceiveProps(nextProps) {
        const {
            match,
            activeTicker: newTicker,
            history,
        } = nextProps;

        const {
            activeTicker: oldTicker,
        } = this.props;

        const newParams = { ...match.params };
        let changed = false;

        const currentPath = getKeyByValue(pathNames, match.path);

        if (currentPath === 'equity' && oldTicker !== newTicker) {
            newParams.ticker = newTicker;
            changed = true;
        }

        if (changed) {
            history.push(reverseRoute(match.path, newParams));
        } else {
            this.synchronizeLocation(nextProps);
        }
    }

    componentWillUnmount() {
        console.log('Unmounting RouteSynchronizer');
    }

    synchronizeLocation = (newProps) => {
        const {
            match: oldMatch,
            activeTicker: oldActiveTicker,
        } = this.props;

        const {
            match: newMatch,
        } = newProps;

        const oldParams = {
            ...oldMatch.params,
            ticker: oldActiveTicker,
        };

        const oldLocation = reverseRoute(newMatch.path, oldParams);

        if (oldLocation !== newMatch.url) {
            if (newMatch.params.ticker && oldActiveTicker !== newMatch.params.ticker) {
                newProps.setActiveTicker({
                    ticker: newMatch.params.ticker,
                });
            }
        }
    }

    render() {
        const {
            match,
            ...otherProps
        } = this.props;

        const title = pageTitles[getKeyByValue(pathNames, match.path)];

        return [
            <Helmet key={title}>
                <meta charSet="utf-8" />
                <title>
                    { title }
                </title>
            </Helmet>,
            <Bundle
                key="component"
                match={match}
                {...otherProps}
            />,
        ];
    }
}

export default RouteSynchronizer;



// WEBPACK FOOTER //
// ./src/common/components/RouteSynchronizer.js